import React from 'react'
import { EditBlogWrapper } from './EditBlog.constants'
export default function EditBlog({ match }) {
    const id = match.params.id
    return (
        <>
            <EditBlogWrapper blog={id} />
        </>
    )
}